import CheckboxList from './CheckboxList';

type Option = {
    id: string;
    label: string; // The display label for the checkbox
    value: unknown; // The unique identifier associated with the checkbox
};

interface GenericCheckboxesProps<ValueType = unknown> {
    options: Array<Option>; // Array of checkbox options
    selectedValues?: Array<ValueType>; // Array of selected values
    onChange: (value: Array<ValueType>) => void; // Callback function for when the selection changes
    defaultAll?: boolean; // Whether to check all checkboxes by default
    id: string; // ID for the CheckboxList component
}

const GenericCheckboxes = <ValueType = unknown,>({
    options,
    selectedValues,
    onChange,
    defaultAll,
    id,
    renderLabel,
}: GenericCheckboxesProps<ValueType>) => {
    if (defaultAll && (!selectedValues || selectedValues.length === 0)) {
        // Default to all being checked
        selectedValues = options.map(opt => opt.value as ValueType);
    }

    return (
        <CheckboxList
            id={id}
            value={selectedValues}
            onUncheckAll={() => {
                if (defaultAll) {
                    // Can deselect all! It'll default to on
                    onChange([options[0]?.value]);
                } else {
                    // No defaulting to on, OK to unselect
                    onChange([]);
                }
            }}
            onChange={(selectedValues: Array<ValueType>) => {
                if (defaultAll && selectedValues.length === options.length) {
                    // All are checked, make it empty
                    onChange([]);
                } else {
                    onChange(selectedValues);
                }
            }}
            options={options}
            renderLabel={renderLabel}
        />
    );
};

export default GenericCheckboxes;
